/* @flow */

import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2';
import 'select2/dist/js/i18n/pt-BR';
import { type Categoria } from './types';
import headersApi from '../utils/headers-api';
import { API } from '../utils/constants';
import alertas from '../alertas';
import titleize from '../utils/titleize';
import api from '../utils/api';

const categoriaParaSelect2 = ({ id, nome }: Categoria) => ({ id, text: nome });

const QUANTIDADE = 50;
const CADASTRAR_CATEGORIA = 'CADASTRAR_CATEGORIA';


const reset = (selector: string) => {
    $(selector)
        .empty()
        .val('')
        .trigger('change');
};

const setValor = (selector: string, { id, nome }: Categoria) => {
    $(selector)
        .append(new global.Option(nome, id))
        .val(id)
        .trigger('change');
};

const getNomeCategoriaOptionSelect2 = (selector: string) => {
    const optionText = $(`${selector} option:selected`).text();
    const [, nomeCategoria] = /"(.*?)"/.exec(optionText) || [];
    return nomeCategoria;
};

const preencherSelectPorId = (selector: string, id: number) => api
    .getCategoriaPorId(id).then(({ data: categoria }) => {
        setValor(selector, categoria);
    });

const criarCategoriaComFeedback = (selector: string, nome: string) => api
    .criarCategoria({ nome })
    .then(({ data: { id } }) => {
        preencherSelectPorId(selector, id)
            .then(() => alertas.categoriaCadastradaComSucesso(nome));
    })
    .catch(alertas.erroCadastrarCategoria);

const onChangeCadastrarCategoria = (selector: string) => {
    if ($(selector).val() !== CADASTRAR_CATEGORIA) {
        return;
    }
    const nomeCategoria = getNomeCategoriaOptionSelect2(selector);
    reset(selector);
    if (!nomeCategoria) {
        return;
    }

    alertas.confirmacaoCadastrarCategoria(nomeCategoria).then(({ value: nome, dismiss }) => {
        if (!nome || dismiss) {
            alertas.erroCadastrarCategoria();
            return;
        }

        criarCategoriaComFeedback(selector, nome);
    });
};

const init = (selector: string) => {
    // $FlowFixMe
    $(selector).select2({
        language: 'pt-BR',
        allow: null,
        width: '100%',
        placeholder: 'Selecione uma categoria',
        ajax: {
            url: `${API}/v2/categorias`,
            delay: 500,
            cache: true,
            headers: headersApi(),
            data: ({ term, page }) => {
                const paginacao = {
                    pagina: page,
                    quantidade: QUANTIDADE,
                };

                if (!term) {
                    return paginacao;
                }

                return {
                    ...paginacao,
                    filtro: {
                        valor: term,
                        opcao: 'contendo',
                    },
                };
            },
            processResults: (data, params) => {
                const more = data.length === QUANTIDADE;
                const results = [{ id: '', text: '' }, ...data.map(categoriaParaSelect2)];

                if (!more && params.term) {
                    results.push({
                        id: CADASTRAR_CATEGORIA,
                        text: `Cadastrar categoria: "${titleize(params.term)}"`,
                    });
                }

                return {
                    results,
                    pagination: {
                        more,
                    },
                };
            },
        },
    });

    $(selector).on('change', onChangeCadastrarCategoria.bind(null, selector));
};

export default {
    init,
    reset,
    setValor,
};
